module.exports = __webpack_public_path__ + "img/ml_get.bca1804.png";